<template>
	<div class="index" v-loading="loading">
		<HeaderInc ref="ref_header" :info="info"></HeaderInc>
		<div class="login_bg">
			<div class="login">
				<div class="login_box">
					<div class="login_title">
						<h1>找回密码</h1>
						<span>直接输入手机号找回密码</span>
					</div>
					<el-form ref="reg_form" :model="reginfo" :rules="rules" status-icon label-width="80px"
						class="demo-ruleForm">
						<el-form-item label="手机号" prop="phone">
							<el-input v-model="reginfo.phone" type="text" autocomplete="off"></el-input>
						</el-form-item>
						<el-form-item label="发送短信">
							<SliderCheck ref="reg_Check" :successFun="regSuccess" :errorFun="regError"></SliderCheck>
						</el-form-item>
						<el-form-item label="验证码" prop="code">
							<el-input v-model="reginfo.code" type="text" autocomplete="off"></el-input>
						</el-form-item>
						<el-form-item label="新密码" prop="password">
							<el-input v-model="reginfo.password" type="password" autocomplete="off"></el-input>
						</el-form-item>
						<el-form-item>
							<a class="login_buttton" @click="submitForm('reg_form')">确定修改</a>
						</el-form-item>
						<el-form-item>
							<el-link @click="backlogin" type="danger">返回登录</el-link>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import httpUtil from '@/util/HttpRequestUtil'
	import SliderCheck from '@/components/SliderCheck.vue'
	import HeaderInc from '@/components/HeaderInc.vue'
	export default {
		name: 'Forget',
		components: {
			SliderCheck,
			HeaderInc
		},
		props: {},
		data() {
			const validatephone = (rule, value, callback) => {
				setTimeout(() => {
					const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
					if ((!reg.test(value)) && value != '') {
						callback(new Error('请输入正确的电话号码'));
					} else {
						callback();
					}
				}, 1000)
			}
			return {
				reginfo: {},
				rules: {
					phone: [{
							required: true,
							message: '请输入手机号',
							trigger: 'blur'
						},
						{
							validator: validatephone,
							trigger: 'blur'
						},
					],
					password: [{
							required: true,
							message: '请输入新密码',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 20,
							message: '长度在6到20个字符',
							trigger: 'blur'
						},
					],
					login_norebots: [{
						required: true,
						message: '请过人机滑块验证',
						trigger: 'blur'
					}, ],
					code: [{
						required: true,
						message: '请输入验证码~',
						trigger: 'blur'
					}, ]
				},
				loading: false,
				info: {
					token: '',
					avatar: '',
					name: ''
				}
			}
		},
		created() {},
		methods: {
			submitForm(formName) {
				var that = this;
				that.$refs[formName].validate((valid) => {
					if (!valid) {
						return false;
					}
					let data = that.reginfo
					data.ac = 'resetpassword'
					httpUtil.post('/api/', data, function(res) {
						if (res.status == 1) {
							that.$message({
								showClose: true,
								message: res.msg,
								type: 'success'
							})
							setTimeout(function() {
								that.$router.isBack = true
								that.$router.push({
									name: 'Index'
								})
							}, 1000)
						} else {
							that.$message.error(res.msg)
							that.$refs.reg_Check.reset()
						}
					})
				})
			},
			regSuccess() {
				var that = this
				that.$refs['reg_form'].validateField('phone', error => {
					if (!error) {
						that.reginfo.reg_norebots = 1;
						let data = {};
						data.ac = "sendcode"
						data.phone = that.reginfo.phone
						httpUtil.post('/api/', data, function(res) {
							if (res.status) {
								that.$message({
									showClose: true,
									message: '短信发送成功~',
									type: 'success'
								})
							} else {
								that.$message.error('短信发送失败~')
								that.$refs.reg_Check.reset()
							}
						});
					} else {
						that.$refs.reg_Check.reset()
						return false
					}
				})
			},
			regError() {
				this.reginfo.reg_norebots = ''
			},
			backlogin() {
				var that = this
				that.$router.isBack = true
				that.$router.push({
					name: 'Index'
				})
			}
		},

	}
</script>
<style>
	.primary {
		color: #198EEB;
		text-decoration: none;
	}
</style>
